import React, { useState } from 'react';
import { Box, Menu, MenuItem, ListItemIcon, ListItemText, IconButton, Tooltip } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CircleIcon from '@mui/icons-material/Circle';
import { MSN } from './msnTheme';

const statusConfig = {
  available: { label: 'Disponível', color: MSN.online },
  busy: { label: 'Ocupado', color: MSN.busy },
  away: { label: 'Ausente', color: MSN.away },
  offline: { label: 'Offline', color: MSN.offline }
};

export default function PresenceStatusSelector({ status, setStatus }) {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Tooltip title={statusConfig[status]?.label || status}>
        <IconButton
          size="small"
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{
            color: statusConfig[status]?.color || MSN.offline,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
          }}
        >
          <FiberManualRecordIcon sx={{ fontSize: 12 }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        PaperProps={{
          sx: {
            bgcolor: MSN.windowBg,
            border: `1px solid ${MSN.border}`,
            borderRadius: 1,
            minWidth: 140,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }
        }}
      >
        {Object.entries(statusConfig).map(([value, { label, color }]) => (
          <MenuItem
            key={value}
            onClick={() => {
              setStatus(value);
              setAnchor(null);
            }}
            selected={status === value}
            sx={{ py: 0.75, fontSize: 13 }}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              <CircleIcon sx={{ fontSize: 8, color }} />
            </ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ fontSize: 13, color: MSN.textPrimary }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
